
import { Link } from 'react-router-dom';
import { List, Header, Image } from 'semantic-ui-react';
import { PersonCourseAttendance } from '../../../../components/Protected/PersonCourseAttendance';
import { PersonBlockAttendance } from '../../../../components/Protected/PersonBlockAttendance';
import { PATHS } from '../../../../paths';
import { sortBlocksDecending } from '../utils/sortBlocksDecending';

// TODO: make this configurable per block cycle
export const CURRENT_BLOCK_SUFFIX = 'APR2026';

export function groupBySku(courses: any[]) {
    return Object.entries(
        courses.reduce((acc: any, c: any) => {
            const sku = c.SKU.slice(-7);
            acc[sku] = acc[sku] ? [...acc[sku], c] : [c];
            return acc;
        }, {})
    ).sort(sortBlocksDecending as any) as [string, any[]][];
}

export const CurrentBlockSection = ({
    attendances,
    personId,
    showSku = true,
}: {
    attendances: any[];
    personId: number;
    showSku?: boolean;
}) => {
    const current = attendances.filter(({ course }: any) => course?.SKU.endsWith(CURRENT_BLOCK_SUFFIX));

    if (current.length === 0) {
        return <p>Not currently enrolled in any classes.</p>;
    }

    return (
        <List divided relaxed>
            {current.map(({ course, attendance }: any) => (
                <List.Item key={course.id}>
                    <List.Content>
                        <List.Header as={Link} to={`${PATHS.CLASSES}/${course.id}`}>
                            {course.name}
                        </List.Header>
                        <List.Description>
                            {course.overseers?.map((t: any) => (
                                <span key={t.id}>
                                    <Image avatar src={t.photoUrl} style={{ width: '2em', height: '2em', objectFit: 'cover' }} />
                                    <Link to={`/people/${t.id}`}>{t.name}</Link>
                                </span>
                            ))}
                            {course.overseers?.length > 0 && <br />}
                            {showSku && <>{course.SKU}<br /></>}
                            Attendance: {attendance.filter((a: any) => a.status === 'PRESENT').length}/{attendance.length}<br />
                            {attendance.map((a: any) => (
                                <span key={a.id} style={{ marginRight: '0.5em' }}>
                                    {a.status === 'ABSENT' ? '❌' : a.status === 'PRESENT' ? '✅' : '❓'}
                                </span>
                            ))}
                        </List.Description>
                    </List.Content>
                </List.Item>
            ))}
        </List>
    );
};

export const CoursesSection = ({
    courses,
    personId,
}: {
    courses: any[];
    personId: number;
}) => {
    if (courses.length === 0) return <p>Not enrolled in any past classes.</p>;

    return (
        <List divided relaxed>
            {groupBySku(courses).map(([sku, skuCourses]) => (
                <List.Item key={sku}>
                    <Header as="h4" style={{ marginBottom: '0.5em' }}>{sku}</Header>
                    {skuCourses.length > 1 && (
                        <>Block Attendance: <PersonBlockAttendance personId={personId} blockCode={sku} /></>
                    )}
                    <List.List>
                        {skuCourses.map((course: any) => (
                            <List.Item key={course.id}>
                                <List.Content>
                                    <List.Header as={Link} to={`${PATHS.CLASSES}/${course.id}`}>
                                        {course.name}
                                    </List.Header>
                                    <List.Description>
                                        {course.SKU}<br />
                                        Attendance: <PersonCourseAttendance personId={personId} courseId={course.id} />
                                    </List.Description>
                                </List.Content>
                            </List.Item>
                        ))}
                    </List.List>
                </List.Item>
            ))}
        </List>
    );
};

export const TeachingSection = ({ courses }: { courses: any[] }) => (
    <List divided relaxed>
        {groupBySku(courses).map(([sku, skuCourses]) => (
            <List.Item key={sku}>
                <Header as="h4" style={{ marginBottom: '0.5em' }}>{sku}</Header>
                <List.List>
                    {skuCourses.map((course: any) => (
                        <List.Item key={course.id}>
                            <List.Content>
                                <List.Header as={Link} to={`${PATHS.CLASSES}/${course.id}`}>
                                    {course.name}
                                </List.Header>
                                <List.Description>Teacher — {course.SKU}</List.Description>
                            </List.Content>
                        </List.Item>
                    ))}
                </List.List>
            </List.Item>
        ))}
    </List>
);
